<template>
  <!-- 安全管理 -->
  <a-layout-content>
    <div>
      <a-form-model
        :model="edit"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="限制项目">
          <a-select
            v-model="edit.type"
            style="width: 250px"
            default-value="0"
            @change="query()"
          >
            <a-select-option
              v-for="item in selectOption.limitlist"
              :key="item.Type"
            >
              {{ item.Name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="黑名单">
          <span style="color: red">每个IP用段行隔开</span>
          <br />
          <a-textarea v-model="edit.IPlist" style="width: 400px; height: 400px">
          </a-textarea>
        </a-form-item>
        <a-form-item label="修改人">
          <span>{{ edit.Editor }}</span>
        </a-form-item>
        <a-form-item label="修改时间">
          <span>{{ edit.Ldt }}</span>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" style="margin-left: 25%" @click="save()">
            提交
          </a-button>
        </a-form-item>
      </a-form-model>
    </div>
  </a-layout-content>
</template>

<script>
export default {
  data() {
    return {
      edit: { IPlist: "", Editor: "", Ldt: "", type: 1 }, //黑名单字段
      labelCol: { span: 3 },
      wrapperCol: { span: 14 },
      selectOption: {
        limitlist: [],
      },
    };
  },
  methods: {
    //查询API
    query() {
      let IParr = "";

      let params = {
        type: this.edit.type,
      };

      this.axios.post("/usermember/getmemberblocklist", params).then((res) => {
        if (res.data.length != 0) {
          this.edit.Editor = res.data[0].Editor;
          this.edit.Ldt = res.data[0].Ldt;

          res.data.forEach(function (item) {
            IParr += item.IP + "\n";
          });
          this.edit.IPlist = IParr.slice(0, IParr.length - 1);
        } else {
          this.edit.Editor = "";
          this.edit.Ldt = "";
          this.edit.IPlist = "";
        }
      });
    },
    //保存IP
    save() {
      let iplist = [];
      let IPstr = this.edit.IPlist;
      let IPArray = IPstr.split(/[\s\n]/);
      let _this = this;
      let goon = true;
      IPArray.forEach(function (value) {
        const v4reg =
          /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        if (!v4reg.test(value) && value != "") {
          goon = false;
          return _this.$message.error(value + "请输入正确的ip");
        }
        var json = {};
        json["Type"] = _this.edit.type;
        json["IP"] = value;
        iplist.push(json);
      });
      if (goon) {
        let params = {
          blocklist: iplist,
        };

        this.axios
          .post("/usermember/SaveMemberBlockList", params)
          .then((res) => {
            if (res.data) {
              this.$message.success("保存成功!");
              this.query();
            } else {
              this.$message.error(res.error);
            }
          });
      }
    },
    //查询下拉限制
    qrydrpItem() {
      this.axios.post("/usermember/getmemberblocktype", "").then((res) => {
        this.selectOption.limitlist = res.data;
      });
    },
  },
  watch: {
    $route(to, from) {
      if (this.$route.params.name === "safemanager") {
        this.query();
      }
    },
  },
  //首次加载
  created() {
    this.query();
    this.qrydrpItem();
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/receptionset/safemanager.vue